import TermsOfService from '../../components/terms-of-service';

export default TermsOfService;
